// src/App.jsx
import React, { useState } from "react";
import Slider from "react-slick";
import Modal from "react-bootstrap/Modal";
import emailjs from "emailjs-com";
import logoWhite from "./assets/img/logoWhite.png";
import TransformYourBusinesswithAI from "./assets/img/TransformYourBusinesswithAI.png";
import AIDevelopment from "./assets/img/AIDevelopment.png";
import MobileAppDevelopment from "./assets/img/MobileAppDevelopment.png";
import CustomApplicationDevelopment from "./assets/img/CustomApplicationDevelopment.png";

import Healthcare from "./assets/img/Healthcare.png";
import Manufacturing from "./assets/img/Manufacturing.png";
import Education from "./assets/img/Education.png";
import Retail from "./assets/img/Retail.png";
import Logistics from "./assets/img/Logistics.png";
import Finance from "./assets/img/Finance.png";

export default function App() {
  const [lgShow, setLgShow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    interest: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const templateParams = { ...formData };

      await emailjs.send(
        "service_ku2prcl",
        "template_lcw6ioj",
        templateParams,
        "4KWP0L6D025MpWqsJ"
      );

      setFormData({
        name: "",
        email: "",
        mobile: "",
        interest: "",
        message: "",
      });

      // Close modal
      setLgShow(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(
        "An error occurred while submitting the form. Please try again later."
      );
    }
  };

  const industriesSliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1200, // large screens
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992, // tablets landscape
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // tablets portrait
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="MainContent">
        {/* Banner */}
        <div className="bannerWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="logoWrap">
                  <a href="#">
                    <img
                      src={logoWhite}
                      className="img-fluid"
                      alt="Hummingtec Pvt Ltd"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <h2>Hummingtec - We Build Intelligent Digital Solutions</h2>
                  <div className="ctaWrap">
                    <a
                      href="https://calendly.com/nitesh-k-humingtec"
                      target="_blank"
                    >
                      Schedule a call
                    </a>
                    <a
                      href="https://www.hummingtec.com/Contact"
                      target="_blank"
                    >
                      Contact us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Intro */}
        <div className="staffAugItroWrap padTop">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img
                    src={TransformYourBusinesswithAI}
                    className="img-fluid"
                    alt="hero"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <h2>
                    Transform Your Business with AI, Custom Software & Mobile
                    Apps
                  </h2>
                  <p>
                    Hummingtec is a next-generation technology company
                    specializing in{" "}
                    <strong>
                      AI development, custom application development, and mobile
                      app solutions.
                    </strong>
                  </p>
                  <p>
                    We help businesses modernize operations, automate workflows,
                    and launch digital products faster through cutting-edge
                    engineering and strategic innovation.
                  </p>
                  <div className="ctaWrap">
                    <a
                      href="https://calendly.com/nitesh-k-humingtec"
                      target="_blank"
                    >
                      Get a Free Strategy Session
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose */}
        <div className="staffAugBenefitsWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Why Choose Hummingtec?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 53 53"
                        >
                          <g>
                            <path
                              d="M8.258 37.194a6.08 6.08 0 0 1-6.073-6.073v-9.846A6.08 6.08 0 0 1 8.258 15.2a.75.75 0 0 1 0 1.5 4.579 4.579 0 0 0-4.573 4.574v9.846a4.579 4.579 0 0 0 4.573 4.573.75.75 0 0 1 0 1.5zM27.128 18.57a.75.75 0 0 1-.75-.75V8.31a4.585 4.585 0 0 0-4.58-4.58 4.539 4.539 0 0 0-3.23 1.34 4.584 4.584 0 0 0-1.34 3.24.75.75 0 0 1-1.5 0c0-1.614.632-3.14 1.777-4.298a6.031 6.031 0 0 1 4.293-1.782 6.087 6.087 0 0 1 6.08 6.08v9.51a.75.75 0 0 1-.75.75z"
                              fill="#9ceebd"
                              opacity="0.65"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M11.38 18.603a.755.755 0 0 1-.214-.03c-2.63-.781-4.467-3.245-4.467-5.992 0-3.445 2.803-6.248 6.249-6.248s6.248 2.803 6.248 6.248a.75.75 0 0 1-1.5 0c0-2.618-2.13-4.748-4.748-4.748s-4.749 2.13-4.749 4.748a4.775 4.775 0 0 0 3.394 4.553.75.75 0 0 1-.213 1.469zM20.908 50.77a6.077 6.077 0 0 1-6.07-6.07.75.75 0 0 1 1.5 0c0 2.52 2.05 4.57 4.57 4.57a4.504 4.504 0 0 0 3.227-1.337A4.509 4.509 0 0 0 25.48 44.7v-9.62a.75.75 0 0 1 1.5 0v9.62c0 1.63-.633 3.155-1.783 4.293a5.988 5.988 0 0 1-4.288 1.777z"
                              fill="#9ceebd"
                              opacity="0.65"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M11.521 47.173c-3.445 0-6.248-2.802-6.248-6.248s2.803-6.248 6.248-6.248a.75.75 0 0 1 0 1.5c-2.618 0-4.748 2.13-4.748 4.748s2.13 4.748 4.748 4.748a4.724 4.724 0 0 0 4.418-3.006.75.75 0 0 1 1.396.55 6.216 6.216 0 0 1-5.814 3.956zM27.127 35.93a5.036 5.036 0 0 1-3.253-1.193.75.75 0 0 1 .97-1.144c.636.54 1.447.837 2.283.837a3.537 3.537 0 0 0 3.533-3.534v-8.79a3.538 3.538 0 0 0-3.533-3.534c-.908 0-1.772.344-2.431.969a.75.75 0 0 1-1.031-1.09 5.016 5.016 0 0 1 3.462-1.38 5.04 5.04 0 0 1 5.033 5.034v8.791a5.039 5.039 0 0 1-5.033 5.034z"
                              fill="#9ceebd"
                              opacity="0.65"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M42.028 32.55a.748.748 0 0 1-.53-.22l-2.56-2.56a1.096 1.096 0 0 0-.77-.32h-6.76a.75.75 0 0 1 0-1.5h6.76c.682 0 1.349.277 1.831.76l2.56 2.56a.75.75 0 0 1-.53 1.28zM31.729 13.1h-4.6a.75.75 0 0 1 0-1.5h4.6c.286 0 .569-.116.776-.318l4.173-4.172a.75.75 0 1 1 1.06 1.06l-4.18 4.18c-.492.48-1.157.75-1.83.75zM35.598 24.58a.75.75 0 0 1-.75-.75v-3.7c0-.694.28-1.364.767-1.838l1.45-1.46a.75.75 0 1 1 1.065 1.056l-1.46 1.47c-.208.203-.322.48-.322.772v3.7a.75.75 0 0 1-.75.75z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M38.814 9.025c-1.719 0-3.117-1.399-3.117-3.117s1.398-3.117 3.117-3.117c1.72 0 3.118 1.398 3.118 3.117s-1.399 3.117-3.118 3.117zm0-4.734c-.892 0-1.617.725-1.617 1.617s.725 1.617 1.617 1.617 1.618-.726 1.618-1.617-.726-1.617-1.618-1.617zM41.568 24.58h-10.16a.75.75 0 0 1 0-1.5h10.16c.304 0 .595-.127.8-.348l3.291-3.543a.75.75 0 1 1 1.099 1.022l-3.29 3.54a2.59 2.59 0 0 1-1.9.83z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M47.698 20.97c-1.719 0-3.117-1.4-3.117-3.118s1.398-3.117 3.117-3.117 3.117 1.398 3.117 3.117-1.398 3.117-3.117 3.117zm0-4.735c-.892 0-1.617.725-1.617 1.617s.725 1.617 1.617 1.617 1.617-.725 1.617-1.617-.726-1.617-1.617-1.617zM43.78 36.525c-1.719 0-3.117-1.399-3.117-3.117s1.398-3.117 3.117-3.117 3.117 1.398 3.117 3.117-1.398 3.117-3.117 3.117zm0-4.734c-.892 0-1.617.725-1.617 1.617s.725 1.617 1.617 1.617 1.617-.726 1.617-1.617-.726-1.617-1.617-1.617zM39.125 18.656c-1.718 0-3.117-1.398-3.117-3.117s1.399-3.117 3.117-3.117 3.118 1.398 3.118 3.117-1.399 3.117-3.118 3.117zm0-4.734c-.891 0-1.617.725-1.617 1.617s.726 1.617 1.617 1.617 1.618-.725 1.618-1.617-.726-1.617-1.618-1.617zM34.428 46.15a.748.748 0 0 1-.53-.22l-1.47-1.47a2.607 2.607 0 0 1-.76-1.83v-3.7a.75.75 0 0 1 1.5 0v3.7c0 .286.117.566.32.77l1.47 1.47a.75.75 0 0 1-.53 1.28z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M43.039 43.81a.749.749 0 0 1-.55-.24l-3.3-3.549a1.093 1.093 0 0 0-.8-.34h-12.16a.75.75 0 0 1 0-1.5h12.16c.724 0 1.397.289 1.894.814l3.305 3.554a.75.75 0 0 1-.55 1.261z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M44.519 48.024c-1.719 0-3.117-1.398-3.117-3.117s1.398-3.117 3.117-3.117 3.117 1.398 3.117 3.117-1.398 3.117-3.117 3.117zm0-4.734c-.892 0-1.617.726-1.617 1.617s.725 1.617 1.617 1.617 1.617-.725 1.617-1.617-.725-1.617-1.617-1.617zM35.947 50.338a3.12 3.12 0 0 1-3.117-3.117 3.12 3.12 0 0 1 3.117-3.118 3.121 3.121 0 0 1 3.117 3.118 3.12 3.12 0 0 1-3.117 3.117zm0-4.735a1.62 1.62 0 0 0-1.617 1.618 1.62 1.62 0 0 0 1.617 1.617 1.62 1.62 0 0 0 1.617-1.617 1.62 1.62 0 0 0-1.617-1.618zM15.585 31.443a.75.75 0 0 1-.75-.75V24.5c0-1.128-.918-2.047-2.047-2.047s-2.047.919-2.047 2.047v6.193a.75.75 0 0 1-1.5 0V24.5c0-1.956 1.592-3.547 3.547-3.547s3.547 1.591 3.547 3.547v6.193a.75.75 0 0 1-.75.75z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M15.585 27.44H9.991a.75.75 0 0 1 0-1.5h5.594a.75.75 0 0 1 0 1.5zM19.927 31.44a.75.75 0 0 1-.75-.75v-8.73a.75.75 0 0 1 1.5 0v8.73a.75.75 0 0 1-.75.75z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M21.498 22.71h-3.142a.75.75 0 0 1 0-1.5h3.142a.75.75 0 0 1 0 1.5zM21.498 31.44h-3.142a.75.75 0 0 1 0-1.5h3.142a.75.75 0 0 1 0 1.5z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>AI-First Engineering</h2>
                        <p>
                          We integrate AI into every product — from automation
                          layers to predictive insights.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="64"
                          height="64"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M391.813 269.23v-26.46a8.08 8.08 0 0 0-6.898-7.994l-31.256-4.625a100.423 100.423 0 0 0-10.346-24.9l18.851-25.4a8.081 8.081 0 0 0-.775-10.531l-18.71-18.71a8.081 8.081 0 0 0-10.531-.775l-25.4 18.851a100.407 100.407 0 0 0-24.9-10.346l-4.625-31.256a8.08 8.08 0 0 0-7.994-6.898h-26.46a8.08 8.08 0 0 0-7.994 6.898l-4.625 31.256a100.423 100.423 0 0 0-24.9 10.346l-25.4-18.851a8.081 8.081 0 0 0-10.531.775l-18.71 18.71a8.081 8.081 0 0 0-.775 10.531l18.851 25.4a100.407 100.407 0 0 0-10.346 24.9l-31.256 4.625a8.08 8.08 0 0 0-6.898 7.994v26.46a8.08 8.08 0 0 0 6.898 7.994l31.256 4.625a100.423 100.423 0 0 0 10.346 24.9l-18.851 25.4a8.081 8.081 0 0 0 .775 10.531l18.71 18.71a8.081 8.081 0 0 0 10.531.775l25.4-18.851a100.423 100.423 0 0 0 24.9 10.346l4.625 31.256a8.08 8.08 0 0 0 7.994 6.898h26.46a8.08 8.08 0 0 0 7.994-6.898l4.625-31.256a100.423 100.423 0 0 0 24.9-10.346l25.4 18.851a8.081 8.081 0 0 0 10.531-.775l18.71-18.71a8.081 8.081 0 0 0 .775-10.531l-18.851-25.4c4.5-7.712 8.007-16.07 10.346-24.9l31.256-4.625a8.08 8.08 0 0 0 6.898-7.994zM367.842 442.88h85.161c-4.47-5.936-4.018-14.4 1.387-19.806a15.101 15.101 0 0 1 10.714-4.438c3.878 0 7.756 1.479 10.714 4.438l24.244 24.244c5.917 5.917 5.917 15.511 0 21.428l-24.244 24.244c-5.917 5.918-15.512 5.918-21.428 0-5.405-5.405-5.857-13.87-1.387-19.806H256"
                              fill="none"
                              stroke="#9ccdee"
                              strokeWidth="15"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeMiterlimit="10"
                              data-original="#9ccdee"
                              opacity="0.65"
                            ></path>
                            <path
                              d="M110.95 94.351a216.099 216.099 0 0 1 73.39-43.43c7.9-2.76 16.54 1.41 19.3 9.31s-1.41 16.54-9.31 19.3c-74.89 26.17-125.21 97.09-125.21 176.47 0 26.32 5.36 51.75 15.92 75.6 10.21 23.05 24.76 43.51 43.24 60.83 6.11 5.72 6.42 15.31.7 21.41-2.98 3.19-7.02 4.8-11.06 4.8-3.71 0-7.43-1.36-10.36-4.09-21.46-20.11-38.36-43.89-50.23-70.68-12.29-27.73-18.51-57.3-18.51-87.87 0-50.73 17.69-98.49 48.09-136.26"
                              fill="none"
                              stroke="#9ccdee"
                              strokeWidth="15"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeMiterlimit="10"
                              data-original="#9ccdee"
                              opacity="0.65"
                            ></path>
                            <path
                              d="M214 473.181h42c58.01 0 112.55-22.59 153.57-63.61s63.61-95.56 63.61-153.57-22.59-112.55-63.61-153.57c-35.58-35.59-81.34-57.29-130.71-62.42l1.77-1.78c4.02-5.9 3.45-13.99-1.78-19.22-5.92-5.92-15.52-5.92-21.43 0l-24.25 24.24c-5.91 5.92-5.91 15.51 0 21.43l24.25 24.25c2.96 2.95 6.83 4.43 10.71 4.43s7.76-1.48 10.72-4.43c4.9-4.91 5.71-12.32 2.49-18.09 91.1 12.41 161.54 90.71 161.54 185.16 0 103.05-83.83 186.88-186.88 186.88H22.65c-8.37 0-15.15 6.78-15.15 15.15s6.78 15.15 15.15 15.15H179"
                              fill="none"
                              stroke="#9ccdee"
                              strokeWidth="15"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeMiterlimit="10"
                              data-original="#9ccdee"
                              opacity="0.65"
                            ></path>
                            <path
                              d="M271.152 210.543V243.4c0 3.227-3.597 5.152-6.282 3.362l-6.629-4.419a4.04 4.04 0 0 0-4.483 0l-6.629 4.419c-2.685 1.79-6.282-.135-6.282-3.362v-32.856"
                              fill="none"
                              stroke="#9ccdee"
                              strokeWidth="15"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeMiterlimit="10"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M301.46 273.501v21.9c0 3.34-2.72 6.06-6.06 6.06h-78.8c-3.34 0-6.06-2.72-6.06-6.06v-78.8c0-3.34 2.72-6.06 6.06-6.06h78.8c3.34 0 6.06 2.72 6.06 6.06v21.9"
                              fill="none"
                              stroke="#9ccdee"
                              strokeWidth="15"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeMiterlimit="10"
                              data-original="#9ccdee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Fast, Agile Delivery</h2>
                        <p>
                          Our accelerator frameworks cut development time by
                          40–60%.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="64"
                          height="64"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <g data-name="11-global network">
                              <path
                                d="M25 54H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h62a1 1 0 0 1 1 1v33h-2V2H2v50h23z"
                                fill="#cb9cee"
                                opacity="1"
                                data-original="#cb9cee"
                              ></path>
                              <path
                                d="M1 6h62v2H1z"
                                fill="#cb9cee"
                                opacity="1"
                                data-original="#cb9cee"
                              ></path>
                              <path
                                d="M8 1h2v6H8zM54 1h2v6h-2zM45 64a19.023 19.023 0 1 1 15.421-7.916A19.03 19.03 0 0 1 45 64zm0-36a17.021 17.021 0 1 0 13.8 7.084A17.025 17.025 0 0 0 45 28z"
                                fill="#cb9cee"
                                opacity="1"
                                data-original="#cb9cee"
                              ></path>
                              <path
                                d="M45 64c-4.547 0-7-9.789-7-19s2.453-19 7-19 7 9.789 7 19-2.453 19-7 19zm0-36c-2.088 0-5 6.468-5 17s2.912 17 5 17 5-6.468 5-17-2.912-17-5-17z"
                                fill="#cb9cee"
                                opacity="1"
                                data-original="#cb9cee"
                              ></path>
                              <path
                                d="M45 38a51.6 51.6 0 0 1-5.437-.275 31.15 31.15 0 0 1-9.594-2.318 1 1 0 0 1-.391-1.49 18.979 18.979 0 0 1 30.844 0 1 1 0 0 1-.391 1.49 31.175 31.175 0 0 1-9.6 2.319A51.743 51.743 0 0 1 45 38zm-13.017-3.922a32.872 32.872 0 0 0 7.79 1.657 52 52 0 0 0 10.451 0 32.924 32.924 0 0 0 7.793-1.658 16.978 16.978 0 0 0-26.034 0zM45 64a19.03 19.03 0 0 1-15.422-7.917 1 1 0 0 1 .391-1.49 31.175 31.175 0 0 1 9.6-2.319 54.238 54.238 0 0 1 10.87 0 31.15 31.15 0 0 1 9.594 2.318 1 1 0 0 1 .391 1.49A19.03 19.03 0 0 1 45 64zm-13.017-8.078a16.978 16.978 0 0 0 26.034 0 32.872 32.872 0 0 0-7.79-1.657 52 52 0 0 0-10.451 0 32.924 32.924 0 0 0-7.793 1.657zM27 44h36v2H27zM20 24H10a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm-9-2h8V12h-8zM37 24H27a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm-9-2h8V12h-8z"
                                fill="#cb9cee"
                                opacity="0.45"
                                data-original="#cb9cee"
                              ></path>
                              <path
                                d="M54 24H44a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm-9-2h8V12h-8zM11 26h10v2H11zM9 30h12v2H9zM9 34h8v2H9zM19 34h2v2h-2zM26 26h6v2h-6zM26 30h3v2h-3zM4 48h8v2H4zM4 44h8v2H4zM14 48h2v2h-2zM18 48h2v2h-2z"
                                fill="#cb9cee"
                                opacity="0.45"
                                data-original="#cb9cee"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Global Experience</h2>
                        <p>
                          Trusted by clients across the US, India, Africa, and
                          the Middle East.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="64"
                          height="64"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M59.506 27.903A27.322 27.322 0 0 0 51.47 9.43C46.267 4.226 39.352 1.361 32 1.361c-14.849 0-26.982 11.819-27.505 26.542a6.474 6.474 0 0 0-3.852 5.911v7.262a6.475 6.475 0 0 0 6.468 6.468 4.19 4.19 0 0 0 4.185-4.185V31.53c0-2.167-1.662-3.934-3.775-4.144C8.301 14.559 18.979 4.361 32 4.361c6.552 0 12.713 2.554 17.35 7.191 4.258 4.258 6.75 9.808 7.125 15.835-2.111.212-3.77 1.978-3.77 4.143v11.828c0 2.185 1.688 3.963 3.826 4.148v2.989a6.111 6.111 0 0 1-6.105 6.104h-4.521a4.497 4.497 0 0 0-4.267-3.038h-4.66c-.669 0-1.311.142-1.899.416a4.547 4.547 0 0 0-2.64 4.122c0 1.214.473 2.354 1.33 3.207a4.504 4.504 0 0 0 3.209 1.332h4.66c1.932 0 3.635-1.249 4.27-3.039h4.518c5.021 0 9.105-4.084 9.105-9.104v-3.523a6.473 6.473 0 0 0 3.826-5.898v-7.262c0-2.634-1.586-4.902-3.851-5.909zM8.295 31.53v11.828c0 .653-.531 1.185-1.185 1.185a3.472 3.472 0 0 1-3.468-3.468v-7.262a3.472 3.472 0 0 1 3.468-3.468c.654 0 1.185.532 1.185 1.185zm34.848 26.891a1.546 1.546 0 0 1-1.506 1.219h-4.66c-.41 0-.795-.16-1.089-.454a1.523 1.523 0 0 1-.45-1.085 1.542 1.542 0 0 1 1.539-1.538h4.66c.41 0 .795.159 1.088.453.29.289.45.675.45 1.085.001.11-.011.22-.032.32zm17.214-17.346a3.472 3.472 0 0 1-3.468 3.468 1.186 1.186 0 0 1-1.185-1.185V31.53c0-.653.531-1.185 1.185-1.185a3.472 3.472 0 0 1 3.468 3.468z"
                              fill="#dcdc30"
                              opacity="1"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M41.713 41.592a6.363 6.363 0 0 0 6.356-6.356V22.285c0-1.694-.662-3.29-1.864-4.492s-2.797-1.864-4.492-1.864H22.287a6.363 6.363 0 0 0-6.356 6.356v12.951a6.363 6.363 0 0 0 6.356 6.356h.119v3.356a3.109 3.109 0 0 0 3.112 3.124 3.05 3.05 0 0 0 2.196-.927l5.583-5.553zm-10.091-2.564-6.042 6.009c-.027.028-.047.049-.104.024-.069-.028-.069-.073-.069-.113v-4.856a1.5 1.5 0 0 0-1.5-1.5h-1.619a3.36 3.36 0 0 1-3.356-3.356V22.285a3.36 3.36 0 0 1 3.356-3.356h19.426c.894 0 1.735.35 2.371.985.636.636.985 1.478.985 2.371v12.951a3.36 3.36 0 0 1-3.356 3.356H32.68c-.397 0-.777.157-1.058.436z"
                              fill="#dcdc30"
                              opacity="0.45"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M24.713 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM31.999 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.222 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM39.285 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.994-2.213-2.215-2.213z"
                              fill="#dcdc30"
                              opacity="0.45"
                              data-original="#dcdc30"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>End-to-End Support</h2>
                        <p>
                          From idea → design → development → deployment →
                          maintenance.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="64"
                          height="64"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M21 62a18.92 18.92 0 0 0 10.507-3.167L30.4 57.167A16.923 16.923 0 0 1 21 60c-9.374 0-17-7.626-17-17s7.626-17 17-17 17 7.626 17 17c0 1.92-.317 3.805-.944 5.602l1.889.658C39.645 47.25 40 45.145 40 43c0-1.023-.104-2.02-.261-3H57c2.757 0 5-2.243 5-5V20a1 1 0 0 0-1-1h-7V3a1 1 0 0 0-1-1H27a1 1 0 0 0-1 1v21.69a18.886 18.886 0 0 0-5-.69C10.523 24 2 32.523 2 43s8.523 19 19 19zm33-41h6v14c0 1.654-1.346 3-3 3s-3-1.346-3-3zM28 4h24v31c0 1.13.391 2.162 1.026 3H39.31A19.06 19.06 0 0 0 28 25.353z"
                              fill="#ff9393"
                              opacity="0.45"
                              data-original="#ff9393"
                            ></path>
                            <path
                              d="M31 17h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1-8h6v6h-6zM42 8h8v2h-8zM42 14h8v2h-8zM36 26h14v2H36zM40 32h10v2H40zM30 20h20v2H30zM31.25 34.338 16.954 50.54l-5.247-5.247-1.414 1.414 6 6A.997.997 0 0 0 17 53h.031c.275-.009.536-.131.719-.338l15-17zM30.718 55.104c1.771.784 2.396 1.408 3.179 3.18a1.208 1.208 0 0 0 2.207-.003c.783-1.77 1.407-2.394 3.179-3.178a1.206 1.206 0 0 0-.001-2.206c-1.771-.784-2.396-1.408-3.179-3.18a1.207 1.207 0 0 0-2.207.002c-.783 1.77-1.407 2.394-3.179 3.178a1.206 1.206 0 0 0 .001 2.207zM35 51.925A6.202 6.202 0 0 0 37.075 54 6.202 6.202 0 0 0 35 56.075 6.202 6.202 0 0 0 32.925 54 6.202 6.202 0 0 0 35 51.925zM3.718 22.104c1.771.784 2.396 1.408 3.179 3.18a1.208 1.208 0 0 0 2.207-.003c.783-1.77 1.407-2.394 3.179-3.178a1.206 1.206 0 0 0-.001-2.206c-1.771-.784-2.396-1.408-3.179-3.18a1.207 1.207 0 0 0-2.207.002c-.783 1.77-1.407 2.394-3.179 3.178a1.206 1.206 0 0 0 .001 2.207zM8 18.925A6.202 6.202 0 0 0 10.075 21 6.202 6.202 0 0 0 8 23.075 6.202 6.202 0 0 0 5.925 21 6.202 6.202 0 0 0 8 18.925z"
                              fill="#ff9393"
                              opacity="1"
                              data-original="#ff9393"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Transparent Pricing & Clear Communication</h2>
                        <p>No surprises. Only measurable results.</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Business Grow */}
        <div className="staffAugItroWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6 d-flex align-items-center">
                <div className="imgWrap">
                  <img
                    src={AIDevelopment}
                    className="img-fluid"
                    alt="AI Development"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <span className="topTag">Our Core Services</span>
                  <h2>AI Development</h2>
                  <p className="mar0px">
                    We design and build AI systems that solve real business
                    problems.
                  </p>
                  <p>
                    <strong>What we deliver :</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>1.</strong> Custom AI Agents & Automation
                    </li>
                    <li>
                      <strong>2.</strong> Predictive Analytics & Forecasting
                    </li>
                    <li>
                      <strong>3.</strong> Machine Learning & Deep Learning
                      Models
                    </li>
                    <li>
                      <strong>4.</strong> RAG / GenAI Assistants for Internal
                      Knowledge
                    </li>
                    <li>
                      <strong>5.</strong> Computer Vision & Document AI
                    </li>
                    <li>
                      <strong>6.</strong> AI Chatbots for Customer & Employee
                      Workflows
                    </li>
                    <li>
                      <strong>7.</strong> Integration with EHRs, CRMs, ERPs, IoT
                      devices
                    </li>
                  </ul>
                  <p className="mar0px">
                    <strong>Results you can expect : </strong>
                  </p>
                  <div className="btmTags">
                    <span>Web and Mobile App Development</span>
                    <span>Real-Time Collaboration Tools</span>
                    <span>Streaming Applications</span>
                    <span>IoT Applications</span>
                    <span>API Services</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What Happens If You Don't Go Digital */}
        <div className="staffAugItroWrap formobile bgClr">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <span className="topTag">Our Core Services</span>
                  <h2>Custom Application Development</h2>
                  <p className="mar0px">
                    We build scalable, secure, high-performance systems tailored
                    to your business processes.
                  </p>
                  <p>
                    <strong>Our expertise includes</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>1. </strong> Web Platforms & Enterprise Portals
                    </li>
                    <li>
                      <strong>2. </strong> Internal Dashboards, Workflow Tools &
                      Management Systems
                    </li>
                    <li>
                      <strong>3. </strong> ERP / CRM Integrations
                    </li>
                    <li>
                      <strong>4. </strong> Cloud-native Applications (AWS,
                      Azure, GCP)
                    </li>
                    <li>
                      <strong>5. </strong> Document Processing & Automation
                    </li>
                    <li>
                      <strong>6. </strong> Data Engineering & Analytics
                      Platforms
                    </li>
                    <li>
                      <strong>7. </strong> Integration with third-party services
                      & legacy systems
                    </li>
                  </ul>
                  <p className="mar0px">
                    <strong>Why teams choose Hummingtec : </strong>
                  </p>
                  <div className="btmTags">
                    <span>Fast delivery using our accelerator components</span>
                    <span>Enterprise-grade architecture</span>
                    <span>High-quality UI/UX and modular code</span>
                    <span>Long-term support & enhancements</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <div className="imgWrap">
                  <img
                    src={CustomApplicationDevelopment}
                    className="img-fluid"
                    alt="Custom Application Development"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="staffAugItroWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6 d-flex align-items-center">
                <div className="imgWrap">
                  <img
                    src={MobileAppDevelopment}
                    className="img-fluid"
                    alt="Mobile App Development"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <span className="topTag">Our Core Services</span>
                  <h2>Mobile App Development</h2>
                  <p className="mar0px">
                    We create seamless mobile experiences across iOS and
                    Android.
                  </p>
                  <p>
                    <strong>We build :</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>1.</strong> Native & Hybrid Mobile Apps
                    </li>
                    <li>
                      <strong>2.</strong> React Native & Flutter Applications
                    </li>
                    <li>
                      <strong>3.</strong> Consumer Apps, B2B Apps, Field Apps
                    </li>
                    <li>
                      <strong>4.</strong> IoT-linked Mobile Interfaces
                    </li>
                    <li>
                      <strong>5.</strong> Telehealth & Patient Engagement Apps
                    </li>
                    <li>
                      <strong>6.</strong> Secure Payment, Booking & Ordering
                      Apps
                    </li>
                  </ul>
                  <p className="mar0px">
                    <strong>Our focus : </strong>
                  </p>
                  <div className="btmTags">
                    <span>Clean design</span>
                    <span>Smooth performance</span>
                    <span>Real-time data syncing</span>
                    <span>User-centric workflows</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="industriesWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Industries We Serve</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Slider
                  {...industriesSliderSettings}
                  className="industries-slider"
                >
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Healthcare}
                          className="img-fluid"
                          alt="Healthcare & Telehealth"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Healthcare & Telehealth</h2>
                      </div>
                    </div>
                  </div>
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Manufacturing}
                          className="img-fluid"
                          alt="Manufacturing & Industry"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Manufacturing & Industry 4.0</h2>
                      </div>
                    </div>
                  </div>
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Education}
                          className="img-fluid"
                          alt="Education & EdTech"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Education & EdTech</h2>
                      </div>
                    </div>
                  </div>
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Retail}
                          className="img-fluid"
                          alt="Retail, Travel & Hospitality"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Retail, Travel & Hospitality</h2>
                      </div>
                    </div>
                  </div>
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Logistics}
                          className="img-fluid"
                          alt="Logistics & Field Services"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Logistics & Field Services</h2>
                      </div>
                    </div>
                  </div>
                  <div className="itemBox">
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <img
                          src={Finance}
                          className="img-fluid"
                          alt="Finance & Professional Services"
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>Finance & Professional Services</h2>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>

        {/* Our Digital Process */}
        <div className="staffOnBoardWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Our Process</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>01</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Discovery & Strategy</h2>
                        <p>
                          We understand your business goals, challenges, and
                          technology needs.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>02</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Design & Architecture</h2>
                        <p>
                          We create user-friendly flows and scalable system
                          designs.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>03</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Development & Integration</h2>
                        <p>
                          Our engineers build clean, reliable, secure
                          applications.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>04</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Testing & Optimization</h2>
                        <p>
                          Every feature is validated for performance, scale, and
                          usability.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="noWrap">
                        <h2>05</h2>
                      </div>
                      <div className="dataWrap">
                        <h2>Launch & Support</h2>
                        <p>
                          We deploy your product and provide ongoing
                          enhancements.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ + Right Column (React accordion) */}
        <div className="staffAugFaqWrap btmConnectWrap">
          <div className="container d-flex">
            <div className="row justify-content-center w-100">
              <div className="col-md-12">
                <div className="rightWrap">
                  <h2>Let’s Build Your Next Big Solution</h2>
                  <p>
                    Whether you’re a startup or an enterprise, we help you turn
                    ideas into intelligent, scalable products.
                  </p>
                  <ul>
                    <li>
                      <div className="icoWrap">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.2906 0.249174C12.878 0.211673 12.5132 0.51568 12.4757 0.928192C12.4382 1.3407 12.7422 1.70551 13.1548 1.74301L13.2906 0.249174ZM22.2533 10.8416C22.2908 11.2541 22.6556 11.5581 23.0681 11.5206C23.4806 11.4831 23.7846 11.1183 23.7471 10.7058L22.2533 10.8416ZM13.2227 0.996094C13.1548 1.74301 13.1543 1.74298 13.1539 1.74294C13.1538 1.74293 13.1534 1.74289 13.1532 1.74287C13.1527 1.74283 13.1523 1.74279 13.1519 1.74275C13.1511 1.74267 13.1505 1.74261 13.15 1.74256C13.149 1.74247 13.1487 1.74243 13.1491 1.74247C13.1497 1.74254 13.1529 1.74289 13.1585 1.74361C13.1698 1.74506 13.191 1.74798 13.2216 1.75308C13.2827 1.76327 13.3816 1.78217 13.5144 1.81537C13.7798 1.88173 14.1816 2.0054 14.6902 2.23144C15.7057 2.68274 17.157 3.54668 18.8033 5.19301L19.864 4.13235C18.0881 2.35653 16.484 1.38718 15.2994 0.860723C14.7081 0.597886 14.2238 0.446563 13.8782 0.360151C13.7054 0.316962 13.5674 0.290028 13.4682 0.273485C13.4186 0.265215 13.3786 0.259543 13.3488 0.255735C13.334 0.253832 13.3216 0.252394 13.3119 0.251331C13.307 0.2508 13.3028 0.250362 13.2992 0.250006C13.2975 0.249828 13.2959 0.249671 13.2944 0.249533C13.2937 0.249464 13.293 0.249399 13.2924 0.249339C13.292 0.24931 13.2916 0.249268 13.2914 0.249253C13.291 0.249213 13.2906 0.249174 13.2227 0.996094ZM18.8033 5.19301C20.4496 6.83934 21.3136 8.29066 21.7649 9.30608C21.9909 9.81467 22.1146 10.2165 22.181 10.482C22.2141 10.6148 22.233 10.7136 22.2432 10.7747C22.2483 10.8053 22.2513 10.8265 22.2527 10.8378C22.2534 10.8434 22.2538 10.8466 22.2538 10.8473C22.2539 10.8476 22.2538 10.8473 22.2538 10.8463C22.2537 10.8459 22.2536 10.8452 22.2536 10.8444C22.2535 10.844 22.2535 10.8436 22.2534 10.8431C22.2534 10.8429 22.2534 10.8425 22.2534 10.8424C22.2533 10.842 22.2533 10.8416 23.0002 10.7737C23.7471 10.7058 23.7471 10.7053 23.7471 10.7049C23.747 10.7047 23.747 10.7043 23.747 10.704C23.7469 10.7033 23.7469 10.7026 23.7468 10.7019C23.7466 10.7005 23.7465 10.6988 23.7463 10.6971C23.746 10.6935 23.7455 10.6893 23.745 10.6844C23.7439 10.6747 23.7425 10.6624 23.7406 10.6475C23.7368 10.6177 23.7311 10.5778 23.7228 10.5281C23.7063 10.4289 23.6794 10.2909 23.6362 10.1182C23.5498 9.77251 23.3984 9.28826 23.1356 8.69687C22.6091 7.51234 21.6398 5.90817 19.864 4.13235L18.8033 5.19301Z"
                            fill="#701A75"
                            opacity="0.4"
                          ></path>
                          <path
                            d="M13.6816 4.59526C13.2834 4.48147 12.8682 4.71209 12.7544 5.11037C12.6406 5.50864 12.8713 5.92376 13.2695 6.03755L13.6816 4.59526ZM17.9398 10.7078C18.0536 11.1061 18.4687 11.3367 18.867 11.2229C19.2652 11.1091 19.4959 10.694 19.3821 10.2957L17.9398 10.7078ZM13.4756 5.31641C13.2695 6.03755 13.2692 6.03745 13.2689 6.03735C13.2688 6.03732 13.2684 6.03723 13.2682 6.03716C13.2678 6.03704 13.2674 6.03692 13.267 6.03681C13.2662 6.03658 13.2655 6.03638 13.2648 6.03619C13.2636 6.03581 13.2626 6.03552 13.2619 6.03531C13.2605 6.03489 13.2603 6.03481 13.2612 6.03511C13.2631 6.03569 13.2695 6.03778 13.2803 6.04163C13.302 6.04932 13.3415 6.0641 13.3976 6.08814C13.5097 6.13618 13.6887 6.22145 13.9254 6.36154C14.3984 6.64147 15.1051 7.14237 15.97 8.00729L17.0307 6.94663C16.0808 5.99669 15.2751 5.41731 14.6894 5.07068C14.3968 4.89749 14.1599 4.7829 13.9884 4.70942C13.9027 4.67269 13.8335 4.64628 13.7819 4.62798C13.7561 4.61884 13.7348 4.61172 13.718 4.60636C13.7096 4.60368 13.7024 4.60143 13.6963 4.5996C13.6933 4.59868 13.6905 4.59786 13.6881 4.59714C13.6869 4.59678 13.6857 4.59644 13.6846 4.59613C13.6841 4.59597 13.6836 4.59582 13.6831 4.59568C13.6828 4.59561 13.6825 4.5955 13.6823 4.59547C13.682 4.59536 13.6816 4.59526 13.4756 5.31641ZM15.97 8.00729C16.835 8.87222 17.3359 9.57894 17.6158 10.0519C17.7559 10.2886 17.8411 10.4677 17.8892 10.5798C17.9132 10.6359 17.928 10.6753 17.9357 10.697C17.9396 10.7079 17.9416 10.7143 17.9422 10.7161C17.9425 10.717 17.9424 10.7168 17.942 10.7154C17.9418 10.7147 17.9415 10.7138 17.9411 10.7125C17.941 10.7118 17.9407 10.7111 17.9405 10.7104C17.9404 10.71 17.9403 10.7096 17.9402 10.7091C17.9401 10.7089 17.94 10.7086 17.94 10.7085C17.9399 10.7081 17.9398 10.7078 18.6609 10.5017C19.3821 10.2957 19.382 10.2953 19.3819 10.295C19.3818 10.2949 19.3817 10.2945 19.3816 10.2943C19.3815 10.2937 19.3814 10.2932 19.3812 10.2927C19.3809 10.2916 19.3805 10.2905 19.3802 10.2892C19.3795 10.2868 19.3787 10.284 19.3777 10.281C19.3759 10.2749 19.3737 10.2677 19.371 10.2593C19.3656 10.2425 19.3585 10.2212 19.3493 10.1954C19.331 10.1438 19.3046 10.0746 19.2679 9.9889C19.1944 9.81744 19.0798 9.58057 18.9067 9.28794C18.56 8.70224 17.9806 7.89658 17.0307 6.94663L15.97 8.00729Z"
                            fill="#701A75"
                            opacity="0.4"
                          ></path>
                          <path
                            d="M9.17234 6.47135L8.51742 6.83685V6.83685L9.17234 6.47135ZM8.37912 5.05003L7.7242 5.41552V5.41552L8.37912 5.05003ZM1.75747 8.27682C1.77316 7.8629 1.45034 7.51464 1.03642 7.49895C0.622503 7.48326 0.274237 7.80608 0.258546 8.22L1.75747 8.27682ZM5.48265 18.5139L6.01298 17.9836L5.48265 18.5139ZM9.58533 14.4112L10.1157 13.8809L9.58533 14.4112ZM17.5252 14.8242L17.1597 15.4791L17.5252 14.8242ZM18.9465 15.6174L19.312 14.9625L18.9465 15.6174ZM15.7481 22.9885L15.7765 23.738L15.7481 22.9885ZM19.4097 21.117L19.94 21.6474L19.4097 21.117ZM2.34917 4.05656C2.05628 4.34945 2.05628 4.82432 2.34917 5.11722C2.64206 5.41011 3.11694 5.41011 3.40983 5.11722L2.34917 4.05656ZM12.2065 21.8003C11.8083 21.6861 11.393 21.9163 11.2788 22.3145C11.1646 22.7127 11.3949 23.128 11.793 23.2422L12.2065 21.8003ZM7.92664 21.4669C8.27472 21.6914 8.73891 21.5912 8.96344 21.2431C9.18796 20.895 9.08779 20.4309 8.73971 20.2063L7.92664 21.4669ZM8.47337 10.5641L9.00372 11.0944L8.47337 10.5641ZM8.47337 10.5641L9.00371 11.0944L8.47337 10.5641ZM13.4324 15.5232L12.9022 14.9927L13.4324 15.5232ZM13.4325 15.5231L13.9628 16.0535L13.4325 15.5231ZM9.82725 6.10585L9.03403 4.68453L7.7242 5.41552L8.51742 6.83685L9.82725 6.10585ZM0.258546 8.22C0.163585 10.7249 0.808273 14.9002 4.95232 19.0442L6.01298 17.9836C2.21135 14.1819 1.67561 10.4361 1.75747 8.27682L0.258546 8.22ZM10.1157 13.8809C8.97185 12.7371 8.83028 11.9694 8.84863 11.5946C8.86791 11.201 9.07325 11.0249 9.00372 11.0944L7.94302 10.0338C7.87337 10.1035 7.39499 10.6112 7.35043 11.5212C7.30494 12.4501 7.71941 13.6059 9.055 14.9415L10.1157 13.8809ZM17.1597 15.4791L18.581 16.2723L19.312 14.9625L17.8907 14.1693L17.1597 15.4791ZM9.055 14.9415C10.3902 16.2768 11.5458 16.6914 12.4746 16.6461C13.3846 16.6018 13.8925 16.1237 13.9626 16.0537L12.9022 14.9927C12.9715 14.9235 12.7953 15.1287 12.4016 15.1479C12.0267 15.1662 11.2592 15.0244 10.1157 13.8809L9.055 14.9415ZM18.8793 20.5867C17.918 21.548 16.8344 22.1968 15.7197 22.2391L15.7765 23.738C17.4326 23.6752 18.8553 22.732 19.94 21.6474L18.8793 20.5867ZM18.581 16.2723C20.0065 17.0679 20.2947 19.1714 18.8793 20.5867L19.94 21.6474C21.9296 19.6578 21.7603 16.3288 19.312 14.9625L18.581 16.2723ZM13.9628 16.0535C14.8811 15.1352 16.2031 14.9453 17.1597 15.4791L17.8907 14.1693C16.282 13.2715 14.2387 13.6562 12.9021 14.9928L13.9628 16.0535ZM9.03403 4.68453C7.6677 2.23628 4.33875 2.06698 2.34917 4.05656L3.40983 5.11722C4.82517 3.70188 6.92867 3.99006 7.7242 5.41552L9.03403 4.68453ZM9.00371 11.0944C10.3403 9.75784 10.7251 7.71459 9.82725 6.10585L8.51742 6.83685C9.05129 7.79345 8.86133 9.1155 7.94304 10.0338L9.00371 11.0944ZM15.7197 22.2391C14.7923 22.2742 13.5816 22.1945 12.2065 21.8003L11.793 23.2422C13.3423 23.6864 14.7141 23.7783 15.7765 23.738L15.7197 22.2391ZM8.73971 20.2063C7.85142 19.6334 6.93498 18.9056 6.01298 17.9836L4.95232 19.0442C5.94723 20.0391 6.94627 20.8345 7.92664 21.4669L8.73971 20.2063ZM9.00372 11.0944L9.00371 11.0944L7.94304 10.0338L7.94302 10.0338L9.00372 11.0944ZM13.9626 16.0537L13.9628 16.0535L12.9021 14.9928L12.9022 14.9927L13.9626 16.0537Z"
                            fill="#701A75"
                          ></path>
                        </svg>
                      </div>
                      <a
                        href="https://calendly.com/nitesh-k-humingtec"
                        target="_blank"
                      >
                        <strong>Book a Free Strategy Call</strong>
                      </a>
                    </li>
                    <li>
                      <div className="icoWrap">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.6 8.99531C6.6 9.43714 6.24183 9.79531 5.8 9.79531C5.35817 9.79531 5 9.43714 5 8.99531C5 8.55348 5.35817 8.19531 5.8 8.19531C6.24183 8.19531 6.6 8.55348 6.6 8.99531Z"
                            fill="#701A75"
                            opacity="0.4"
                          ></path>
                          <path
                            d="M9.8 8.99531C9.8 9.43714 9.44183 9.79531 9 9.79531C8.55817 9.79531 8.2 9.43714 8.2 8.99531C8.2 8.55348 8.55817 8.19531 9 8.19531C9.44183 8.19531 9.8 8.55348 9.8 8.99531Z"
                            fill="#701A75"
                            opacity="0.4"
                          ></path>
                          <path
                            d="M13 8.99531C13 9.43714 12.6418 9.79531 12.2 9.79531C11.7582 9.79531 11.4 9.43714 11.4 8.99531C11.4 8.55348 11.7582 8.19531 12.2 8.19531C12.6418 8.19531 13 8.55348 13 8.99531Z"
                            fill="#701A75"
                            opacity="0.4"
                          ></path>
                          <path
                            d="M13 2.06635C11.8233 1.38567 10.4571 0.996094 9 0.996094C4.58172 0.996094 1 4.57782 1 8.99609C1 10.2758 1.30049 11.4854 1.83477 12.5581C1.97675 12.8431 2.02401 13.1689 1.94169 13.4766L1.46521 15.2574C1.25836 16.0305 1.96561 16.7377 2.73868 16.5309L4.51951 16.0544C4.82715 15.9721 5.15297 16.0193 5.43802 16.1613C6.51069 16.6956 7.72025 16.9961 9 16.9961C13.4183 16.9961 17 13.4144 17 8.99609C17 7.53895 16.6104 6.17279 15.9297 4.99609"
                            stroke="#701A75"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          ></path>
                        </svg>
                      </div>
                      <a href="mailto:info@hummingtec.com">
                        <strong>info@hummingtec.com</strong>
                      </a>
                    </li>
                    <li>
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="18"
                          height="18"
                          x="0"
                          y="0"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M2.586 22.715C1.571 20.695 1 18.413 1 16s.571-4.695 1.586-6.715C5.051 4.373 10.135 1 16 1s10.949 3.373 13.414 8.285C30.429 11.305 31 13.587 31 16s-.571 4.695-1.586 6.715C26.949 27.627 21.865 31 16 31S5.051 27.627 2.586 22.715zm1.4-11.688C3.351 12.559 3 14.239 3 16s.351 3.441.986 4.973c1.633-.633 3.558-1.141 5.683-1.483-.11-1.118-.169-2.287-.169-3.49s.059-2.372.169-3.49c-2.125-.342-4.05-.85-5.683-1.483zm23.115-1.791a13.041 13.041 0 0 0-7.376-5.693c.139.216.274.445.404.687.853 1.593 1.535 3.769 1.945 6.298 1.868-.303 3.569-.744 5.027-1.292zM12.275 3.543a13.041 13.041 0 0 0-7.376 5.693c1.458.549 3.159.989 5.027 1.292.41-2.529 1.092-4.705 1.945-6.298.13-.242.265-.471.404-.687zm15.739 17.43C28.649 19.441 29 17.761 29 16s-.351-3.441-.986-4.973c-1.633.633-3.558 1.141-5.683 1.483.11 1.118.169 2.287.169 3.49s-.059 2.372-.169 3.49c2.125.342 4.05.85 5.683 1.483zM4.899 22.764a13.041 13.041 0 0 0 7.376 5.693 10.113 10.113 0 0 1-.404-.687c-.853-1.593-1.535-3.769-1.945-6.298-1.868.303-3.569.744-5.027 1.292zm14.826 5.693a13.041 13.041 0 0 0 7.376-5.693c-1.458-.548-3.159-.989-5.027-1.292-.41 2.529-1.092 4.705-1.945 6.298-.13.242-.265.471-.404.687zM16 3c-.385 0-.745.183-1.091.477-.464.394-.888.975-1.275 1.698-.764 1.426-1.364 3.365-1.73 5.616 1.31.137 2.682.209 4.096.209s2.786-.073 4.096-.209c-.366-2.251-.966-4.19-1.73-5.616-.387-.723-.811-1.304-1.275-1.698C16.745 3.183 16.385 3 16 3zm0 26c.385 0 .745-.183 1.091-.477.464-.394.888-.975 1.275-1.698.764-1.426 1.364-3.365 1.73-5.616C18.786 21.073 17.414 21 16 21s-2.786.073-4.096.209c.366 2.251.966 4.19 1.73 5.616.387.723.811 1.304 1.275 1.698.346.294.706.477 1.091.477zm4.35-9.773c.098-1.034.15-2.115.15-3.227s-.052-2.193-.15-3.227c-1.391.148-2.849.227-4.35.227s-2.959-.079-4.35-.227c-.098 1.034-.15 2.115-.15 3.227s.052 2.193.15 3.227C13.041 19.079 14.499 19 16 19s2.959.079 4.35.227z"
                              fill="#701A75"
                              opacity="1"
                              data-original="#701A75"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <a
                        href="https://www.hummingtec.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <strong> https://www.hummingtec.com/</strong>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="stickCtaWrap">
          <button className="btn" onClick={() => setLgShow(true)}>
            Connect with us
          </button>
        </div>

        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          className="contactUsPopup"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="titleWrap">
              <h2>Let's get in touch</h2>
              <p>
                Kindly fill out the form below, and our team will promptly
                respond to your inquiries.
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              <ul className="formList">
                <li>
                  <div className="inputField">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField">
                    <label>Mobile Number</label>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField selectField">
                    <label>I'm interested in:</label>
                    <select
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                    >
                      <option value="">Select an option</option>
                      <option>Artificial Intelligence</option>
                      <option>Machine Learning</option>
                      <option>Custom GPT</option>
                      <option>Blockchain/Etherium</option>
                      <option>E-Commerce/Shopping Cart</option>
                      <option>Salesforce CRM</option>
                      <option>Zoho CRM</option>
                      <option>Custom CRM</option>
                      <option>Website Development</option>
                      <option>SEO</option>
                      <option>Social Media Management</option>
                      <option>Mobile Application Development</option>
                      <option>Custom Application Development</option>
                      <option>Security and Testing</option>
                      <option>Other</option>
                    </select>
                  </div>
                </li>
                <li className="full">
                  <div className="inputField">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </li>
                <li className="full">
                  <div className="ctaWrap">
                    <button type="submit" className="btnSubmti">
                      Submit
                    </button>
                  </div>
                </li>
              </ul>
            </form>
          </Modal.Body>
        </Modal>
      </div>
      <div className="footerWrap">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p>Copyright @2025, All Rights Reserved</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
